import { read, write } from '../hub/hubApi';
import type { OrganizationCard, ProductCard } from '../public/publicApi';

export interface PromotionPlan { code: string; name: string; price: number; currencyCode: string; audienceSize: number }
export interface PromotionCampaign {
  businessName?: string | null; productName?: string | null;
  id: string; organizationId: string; profileId: string; planCode: string; kind: string; itemRef: string | null;
  price: number; currencyCode: string; audienceSize: number; reachedUsers: number; status: string;
}
export interface PromotionTargets {
  unavailableProductCodes?: string[];
  profiles: { id: string; productCode: string; displayName: string | null; slug: string }[];
  products: ProductCard[];
}
export interface Placement { id: string; kind: string; business: OrganizationCard; product: ProductCard | null }
export const promotionApi = {
  plans: (signal?: AbortSignal) => read<PromotionPlan[]>('/promotions/plans', undefined, signal),
  targets: (signal?: AbortSignal) => read<PromotionTargets>('/promotions/targets', undefined, signal),
  campaigns: (admin: boolean, signal?: AbortSignal) => read<PromotionCampaign[]>(`/promotions/${admin ? 'admin/' : ''}campaigns`, undefined, signal),
  request: (planCode: string, profileId: string, kind: string, itemRef: string | null) =>
    write('/promotions/campaigns', { planCode, profileId, kind, itemRef }, 'post'),
  review: (id: string, approve: boolean) => write(`/promotions/admin/campaigns/${id}/review`, { approve }, 'post'),
  placements: (lang: string, signal?: AbortSignal) => read<Placement[]>('/promotions/placements', { lang }, signal),
  view: (id: string) => write(`/promotions/placements/${id}/view`, {}, 'post'),
};
